import { getWorkstation } from "@/util/indexDb/workstationIndexDb";
import { getCounterTypeFromCookie, COUNTER_TYPE_SCOPE } from "@/helper/posSevenStarConfig";

/**
 * Workstation + counter details sent with POS money APIs (same fields as bookSeats / bookFnb),
 * so the server can stamp transaction_cash / cash_card_logs per workstation & counter.
 * @param {"schedule"|"fnb"} scope - which counter cookie to read
 */
export async function getPosWorkstationPayload(scope = COUNTER_TYPE_SCOPE.SCHEDULE) {
  let workstationType = "";
  try {
    workstationType = await getWorkstation();
  } catch (err) {
    console.log("getPosWorkstationPayload: workstation lookup failed", err);
  }

  let counterType = getCounterTypeFromCookie(scope);
  // Cash card top-up / refund screens may run on an F&B-only counter
  if (!counterType.counter_type_id && scope !== COUNTER_TYPE_SCOPE.FNB) {
    counterType = getCounterTypeFromCookie(COUNTER_TYPE_SCOPE.FNB);
  }

  return {
    hardware_id: null,
    hardware_name: null,
    hardware_mac_address: null,
    workstation_type: workstationType || null,
    counter_type: counterType.counter_type || null,
    counter_type_id: counterType.counter_type_id || null,
  };
}

/** Current POS shift (user_shift_logs.usl_id) from the logged-in shift data. */
export function getPosShiftId() {
  try {
    const shift = JSON.parse(window.localStorage.getItem("USER_SHIFT_DATA") || "null");
    return (shift && shift.usl_id) || null;
  } catch (err) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/helper/posWorkstationPayload.js